import dynamic from 'next/dynamic'

const IconBedAndBreakfast = dynamic(() => import('client/icons/boards/BedBreakfast'))
const IconLunch = dynamic(() => import('client/icons/boards/Lunch'))
const IconLunchAndDrink = dynamic(() => import('client/icons/boards/LunchAndDrink'))
const IconSelfCatering = dynamic(() => import('client/icons/boards/SelfCatering'))
const IconFullKitchen = dynamic(() => import('client/icons/boards/FullKitchen'))
const IconAllInclusive = dynamic(() => import('client/icons/boards/AllInclusive'))
const IconRoomOnly = dynamic(() => import('client/icons/boards/RoomOnly'))

export const codeBoardMap = new Map([
  [
    'AB',
    {
      key: 'breakfast',
      name: 'global.breakfast',
      icon: IconBedAndBreakfast,
      description: 'board.breakfast',
    },
  ],
  [
    'AI',
    {
      key: 'all-inclusive',
      name: 'global.all-inclusive',
      icon: IconAllInclusive,
      description: 'board.all-inclusive',
    },
  ],
  [
    'AS',
    {
      key: 'all-inclusive',
      name: 'global.all-inclusive',
      icon: IconAllInclusive,
      description: 'board.special-all-inclusive',
    },
  ],
  [
    'BB',
    {
      key: 'breakfast',
      name: 'global.breakfast',
      icon: IconBedAndBreakfast,
      description: 'board.breakfast',
    },
  ],
  [
    'BH',
    {
      key: 'half-board',
      name: 'global.1-breakfast-1-half-board',
      icon: IconLunch,
      description: 'board.1-breakfast-1-half-board',
    },
  ],
  [
    'CB',
    {
      key: 'breakfast',
      name: 'global.breakfast',
      icon: IconBedAndBreakfast,
      description: 'board.continental-breakfast',
    },
  ],
  [
    'DB',
    {
      key: 'breakfast',
      name: 'global.breakfast',
      icon: IconBedAndBreakfast,
      description: 'board.breakfast',
    },
  ],
  [
    'FB',
    {
      key: 'full-board',
      name: 'global.full-board',
      icon: IconLunch,
      description: 'board.full-board',
    },
  ],
  [
    'FH',
    {
      key: 'full-board',
      name: 'global.1-half-board-1-full-board',
      icon: IconLunch,
      description: 'board.1-half-1-full',
    },
  ],
  [
    'GB',
    {
      key: 'breakfast',
      name: 'global.breakfast',
      icon: IconBedAndBreakfast,
      description: 'board.breakfast',
    },
  ],
  [
    'HB',
    {
      key: 'half-board',
      name: 'global.half-board',
      icon: IconLunch,
      description: 'board.half-board',
    },
  ],
  [
    'IB',
    {
      key: 'breakfast',
      name: 'global.breakfast',
      icon: IconBedAndBreakfast,
      description: 'board.breakfast',
    },
  ],
  [
    'MB',
    {
      key: 'half-board',
      name: 'global.half-board-plus-beverages',
      icon: IconLunchAndDrink,
      description: 'board.half-board-beverages',
    },
  ],
  [
    'PB',
    {
      key: 'full-board',
      name: 'global.full-board-plus-beverages',
      icon: IconLunchAndDrink,
      description: 'board.full-board-beverages',
    },
  ],
  [
    'RO',
    {
      key: 'room-only',
      name: 'global.room-only',
      icon: IconRoomOnly,
      description: 'global.room-only',
    },
  ],
  [
    'SB',
    {
      key: 'breakfast',
      name: 'global.breakfast',
      icon: IconBedAndBreakfast,
      description: 'board.breakfast',
    },
  ],
  [
    'SC',
    {
      key: 'self-catering',
      name: 'global.self-catering',
      icon: IconSelfCatering,
      description: 'board.self-catering',
    },
  ],
  [
    'B1',
    {
      key: 'breakfast',
      name: 'global.breakfast-for-1',
      icon: IconBedAndBreakfast,
      description: 'board.breakfast-for-1',
    },
  ],
  [
    'B2',
    {
      key: 'breakfast',
      name: 'global.breakfast-for-2',
      icon: IconBedAndBreakfast,
      description: 'board.breakfast-for-2',
    },
  ],
  [
    'BD',
    {
      key: 'half-board',
      name: 'global.half-board',
      icon: IconLunch,
      description: 'board.half-board',
    },
  ],
  [
    'CAB',
    {
      key: 'breakfast',
      name: 'global.breakfast',
      icon: IconBedAndBreakfast,
      description: 'board.breakfast',
    },
  ],
  ['CE', { key: 'dinner', name: 'global.dinner', icon: IconLunch, description: 'board.dinner' }],
  ['CO', { key: 'lunch', name: 'global.lunch', icon: IconLunch, description: 'board.lunch' }],
  ['FD', { key: 'dinner', name: 'global.dinner', icon: IconLunch, description: 'board.dinner' }],
  [
    'FK',
    {
      key: 'full-kitchen',
      name: 'global.full-kitchen',
      icon: IconFullKitchen,
      description: 'board.full-kitchen',
    },
  ],
  [
    'FL+FD',
    {
      key: 'full-board',
      name: 'global.full-board',
      icon: IconLunch,
      description: 'board.full-board',
    },
  ],
  [
    'TFO',
    { key: 'buffet', name: 'global.buffet', icon: IconSelfCatering, description: 'board.buffet' },
  ],
  ['FLL', { key: 'lunch', name: 'global.lunch', icon: IconLunch, description: 'board.lunch' }],
  [
    'SAI',
    {
      key: 'all-inclusive',
      name: 'global.soft-all-inclusive',
      icon: IconAllInclusive,
      description: 'board.soft-inclusive',
    },
  ],
  [
    'BL',
    {
      key: 'half-board',
      name: 'global.half-board',
      icon: IconLunch,
      description: 'board.breakfast-lunch',
    },
  ],
])

export const hasBreakfast = (code: string) => {
  return (
    codeBoardMap.get(code)?.key === 'breakfast' ||
    codeBoardMap.get(code)?.key === 'half-board' ||
    codeBoardMap.get(code)?.key === 'full-board' ||
    codeBoardMap.get(code)?.key === 'all-inclusive' ||
    codeBoardMap.get(code)?.key === 'soft-all-inclusive'
  )
}

export const isAllInclusive = (code: string) => {
  return (
    codeBoardMap.get(code)?.key === 'all-inclusive' ||
    codeBoardMap.get(code)?.key === 'soft-all-inclusive'
  )
}
